/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { LeadingIcon4 } from "../../icons/LeadingIcon4";
import { TrailingIcon14 } from "../../icons/TrailingIcon14";
import "./style.css";

export const Button = ({
  type,
  size,
  leadingIcon,
  trailingIcon,
  className,
  divClassName,
  text = "Small",
  trailingIcon14StyleOverrideClassName,
  trailingIcon14Color = "#074EE8",
}) => {
  return (
    <div className={`button ${type} ${size} ${className}`}>
      {leadingIcon && (
        <LeadingIcon4
          className={`${size === "large" ? "class" : "class-2"}`}
          color={type === "solid" ? "white" : "#074EE8"}
        />
      )}

      <div className={`div ${divClassName}`}>
        {size === "small" && <>{text}</>}

        {size === "medium" && <>Medium</>}

        {size === "large" && <>Large</>}
      </div>

      {trailingIcon && (
        <TrailingIcon14
          className={trailingIcon14StyleOverrideClassName}
          color={trailingIcon14Color}
        />
      )}
    </div>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(["text", "outlined", "solid"]),
  size: PropTypes.oneOf(["large", "medium", "small"]),
  leadingIcon: PropTypes.bool,
  trailingIcon: PropTypes.bool,
  text: PropTypes.string,
  trailingIcon14Color: PropTypes.string,
};
